import { ScheduledMessageFormKey } from '@asset/enum/chatEnum';
import { IconChevronDown } from '@tabler/icons-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@components/ui/dropdown-menu';
import * as S from '@styles/chat/scheduleMessage.style';
import { STUDENT_SELECTOR_CONTENT_CLASS_NAME } from 'constants/chat';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function StudentSelector({
  scheduledMessageForm,
  students
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(S.StudentSelectorGlobalStyle, {}), /*#__PURE__*/_jsx(S.StudentSelector, {
      children: /*#__PURE__*/_jsxs(DropdownMenu, {
        children: [/*#__PURE__*/_jsx(DropdownMenuTrigger, {
          asChild: true,
          children: /*#__PURE__*/_jsxs("button", {
            children: [scheduledMessageForm.watch(ScheduledMessageFormKey.RECIPIENT)?.name ?? '-', /*#__PURE__*/_jsx(IconChevronDown, {
              size: 16,
              color: "var(--gray-10)"
            })]
          })
        }), /*#__PURE__*/_jsx(DropdownMenuContent, {
          className: STUDENT_SELECTOR_CONTENT_CLASS_NAME,
          side: "right",
          align: "start",
          children: students.map(student => /*#__PURE__*/_jsxs(DropdownMenuItem, {
            selected: scheduledMessageForm.watch(ScheduledMessageFormKey.RECIPIENT)?.channelUrl === student.sendbirdChannelUrl,
            onClick: () => {
              scheduledMessageForm.setValue(ScheduledMessageFormKey.RECIPIENT, {
                name: student.name,
                channelUrl: student.sendbirdChannelUrl
              }, {
                shouldDirty: true
              });
            },
            children: [/*#__PURE__*/_jsx("span", {
              children: student.name
            }), /*#__PURE__*/_jsx("span", {
              children: student.schoolName
            })]
          }, student.id))
        })]
      })
    })]
  });
}
export default StudentSelector;